import ChainProfile from './ChainProfile';
import './ChainProfile.scss';

export default ChainProfile;